import moment from 'moment'

/**
 * Service containing date utilities
 */
class DateService {
  /**
   * Format the date
   *
   * @param {Date} date Date
   * @param {string} format Format
   * @param {object} options Format options
   * @param {object} options.local To local timezone
   * @returns {Date} Formatted date
   */
  format (date, format, { local = true } = {}) {
    let formattedDate = moment.utc(date)
    if (local) {
      formattedDate = formattedDate.local()
    }

    return formattedDate.format(format)
  }
}

export const dateService = new DateService()
